import { Variant } from 'services/generated/commerce-service/models/Variant';
import Image from 'next/image';
import { getPriceValues } from 'ui/utils/variantHelpers';
import { getFormatters } from 'ui/hooks/formatter';
import { Currency, Language, Region } from '@whoop/i18n';
import clsx from 'clsx';
interface FeaturedProductCardProps {
  variant: Variant;
  title: string;
  subtitle: string;
  footerText: string;
  forceSmall: boolean;
  currency: Currency;
  language: Language;
  region: Region;
}
export default function FeaturedProductCard({
  variant,
  title,
  subtitle,
  footerText,
  currency,
  language,
  region,
  forceSmall
}: FeaturedProductCardProps) {
  const {
    formatPrice
  } = getFormatters({
    currency,
    language,
    region
  });
  const {
    displayPrice,
    originalPrice,
    isDiscounted
  } = getPriceValues(variant);
  return <div className={clsx(forceSmall ? '' : 'md:h-[140px]', 'flex h-[125px] w-full max-w-lg gap-3 overflow-hidden rounded-2xl bg-white pr-4 text-left')} data-sentry-component="FeaturedProductCard" data-sentry-source-file="FeaturedProductCard.tsx">
      <div className='relative h-full w-[90px] flex-shrink-0 md:w-[110px]'>
        <Image className={'rounded-l-2xl object-cover'} fill src={variant.images.find(image => image.label === 'featured-product-card-img')?.url ?? ''} alt={'Product Image'} data-sentry-element="Image" data-sentry-source-file="FeaturedProductCard.tsx" />
      </div>
      <div className={clsx(forceSmall ? '' : 'md:my-3', 'my-2 flex flex-1 flex-col justify-between')}>
        <div>
          <h3 className={clsx(forceSmall ? '' : ' md:text-xl', 'text-base font-bold')}>
            {title}
          </h3>
          <p className={clsx(forceSmall ? '' : 'md:text-base', 'text-sm')}>
            {subtitle}
          </p>
        </div>
        <div className={clsx(forceSmall ? '' : 'md:text-base', 'flex justify-between text-xs font-bold')}>
          <p>{footerText}</p>
          <div className={'flex gap-2'}>
            {isDiscounted ? <div>{formatPrice(displayPrice)}</div> : null}
            <div className={`text-gray-60 ${isDiscounted ? 'line-through' : ''}`}>
              {formatPrice(originalPrice)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}